(function () {

    'use strict';

    angular.module('Services').factory('SharedCarrierProfilesTableService', SharedCarrierProfilesTableService);

    SharedCarrierProfilesTableService.$inject = ['Carrier', 'TableLiteFactory', '$location', 'ConfirmationModalFactory', 'toastr'];

    function SharedCarrierProfilesTableService(Carrier, TableLiteFactory, $location, ConfirmationModalFactory, toastr) {
        return function (carriers, companyId) {
            const carrierEnableSharingConfirmation = new ConfirmationModalFactory({}, {
                message: 'messages.warning.enableCarrierToNetwork.MESSAGE',
                code: 'messages.warning.enableCarrierToNetwork.CODE',
            });
            const carrierDisableSharingConfirmation = new ConfirmationModalFactory({}, {
                message: 'messages.warning.disableCarrierToNetwork.MESSAGE',
                code: 'messages.warning.disableCarrierToNetwork.CODE',
            });
            const tableStructure = {
                tableName: 'CarrierProfilesTable',
                optionAddOns: {
                    buttons: [{
                        class: 'btn-success',
                        label: 'Activate',
                        tooltip: 'Activate selected carrier profile\'s network effect',
                        onClick: function(){
                            carrierEnableSharingConfirmation.getInstance().result.then(cond=>{
                                if(cond){
                                    const selected = tableStructure.data.filter(item=>item.isSelected);
                                    if(!selected.length){
                                        toastr.error('There are no selected carrier profile', 'Unable to perform operation');
                                        return;
                                    }
                                    const ids = selected.map(item=>item.id);
                                    Carrier.activateCarrierProfilesToNetwork(ids, data=>{
                                        toastr.success('Successfully activated selected carrier profiles');
                                        sendRequest();
                                    }, error=> toastr.error('Unable to perform operation',error.message));
                                }
                            });
                        }
                    }, {
                        class: 'btn-danger',
                        label: 'Deactivate',
                        tooltip: 'Deactivate selected carrier profile\'s network effect',
                        onClick: function(){
                            carrierDisableSharingConfirmation.getInstance().result.then(cond=>{
                                if(cond){
                                    const selected = tableStructure.data.filter(item=>item.isSelected);
                                    if(!selected.length){
                                        toastr.error('There are no selected carrier profile', 'Unable to perform operation');
                                        return;
                                    }
                                    const ids = selected.map(item=>item.id);
                                    Carrier.deactivateCarrierProfilesToNetwork(ids, data=>{
                                        toastr.success('Successfully deactivated selected carrier profiles');
                                        sendRequest();
                                    }, error=> toastr.error('Unable to perform operation',error.message));
                                }
                            });
                        }
                    }]
                },
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noTopOptions: false,
                    noFooter: false
                },
                headers: [{
                    label: 'SELECT ALL',
                    class: 'text-center',
                    width: '70px',
                    viewName: 'checkAll',
                    filter: {
                        type: 'checkbox',
                        viewnName: 'enableDisable'
                    }
                }, {
                    label: 'PROFILE NAME',
                    viewName: 'linkName',
                    filterName: 'name',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        },
                        model: ''
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },{
                    label: "CARRIER",
                    viewName: "carrierLogo",
                    filterName: "carrierId",
                    filter: {
                        type: "select2",
                        placeholder: "Search",
                        filterBy : 'id',
                        items: carriers,
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },  {
                    label: 'SHARED TO RESELLER',
                    viewName: 'companies',
                    filterName: 'companies',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        },
                        model: ''
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Network Activated',
                    viewName: 'networkActivated',
                    filterName: 'networkEffect.activated',
                    filter: {
                        type: 'select2',
                        placeholder: 'Select One',
                        items: ['Activated', 'Deactivated'],
                        onSelect: function(header) {
                            var filter = {};

                            if (header.filter.model === 'Activated') {
                                filter[header.filterName] = true;
                            }else{
                                filter[header.filterName] = false;
                            }

                            sendRequest(filter);
                        }
                    },
                    headerFn: function() {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Network Shared',
                    viewName: 'networkEnabled',
                    filterName: 'networkEffectEnabled',
                    filter: {
                        type: 'select2',
                        placeholder: 'Select One',
                        items: ['On', 'Off'],
                        onSelect: function(header) {
                            var filter = {};

                            if (header.filter.model === 'On') {
                                filter[header.filterName] = true;
                            }else{
                                filter[header.filterName] = false;
                            }

                            sendRequest(filter);
                        }
                    },
                    headerFn: function() {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Action',
                    viewName: 'action'
                }],
                data: []
            };
            const tableActions = new TableLiteFactory(tableStructure,
                {
                    serviceCallback: Carrier.getExternalCarrierProfiles,
                    callbackFormat: ['success','error','filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    defaultFilters : {
                        size: 10,
                        page: 0,
                        sort: 'id,desc',
                        isOwned: true,
                        companyId
                    }
                }
            );
            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;

            function buildTableData(data) {
                /*** START - Building of Data ***/
                tableActions.initializeTableData(data);
                angular.forEach(data.content, function (row, index) {
                    row.companies = {
                        type: 'multipleLink',
                        list: [
                            {
                                label: 'Bba Mastro',
                                link: '/clients/company/details/' + 1
                            },
                            {
                                label: 'Alfa Logisics',
                                link: '/clients/company/details/' + 57
                            }
                        ]
                    };
                    row.linkName = row.linkName = {
                        type: 'link',
                        label: row.name,
                        link: '/carriers/carrier-profiles/' + row.id
                    };
                    if (row.phone1 && row.phone2) {
                        row.phone = {
                            type: 'multiLine',
                            list: [row.phone1, row.phone2]
                        };
                    } else {
                        row.phone = row.phone1 || row.phone2 || 'N/A';
                    }
                    //row.href = '/carriers/carrier-profiles/' + row.id;
                    row.networkEffectEnabled = {
                        type: 'status',
                        status: row.networkEffectEnabled,
                        label: row.networkEffectEnabled ? 'True' : 'False'
                    };
                    row.email = row.email || 'N/A';
                    row.carrierLogo = {
                        imgSrc: angular.getObjVal(row,'carrier.logoUrl'),
                        type: 'logotype'
                    };
                    row.networkActivated = {
                        type: 'status',
                        status: angular.getObjVal(row, 'networkEffect.activated'),
                        label: angular.getObjVal(row, 'networkEffect.activated') ? 'Activated' : 'Deactivated'
                    };
                    row.networkEnabled = {
                        type: 'status',
                        status: angular.getObjVal(row, 'networkEffectEnabled'),
                        label: angular.getObjVal(row, 'networkEffectEnabled') ? 'On' : 'Off'
                    };
                    row.action = {
                        type:'button',
                        buttons: [{
                            text: 'Shared Service Profiles',
                            tooltip: 'View reseller\'s shared s ervice profiles',
                            icon: '',
                            class: 'btn-primary',
                            action: (item) => {
                                $location.path('/networking/' + companyId + '/shared-services/' + item.id);
                            }
                        }]
                    };
                    tableStructure.data.push(row);
                });
            };
            this.tableData = tableStructure;
        };
    };
})();



// WEBPACK FOOTER //
// ./js/services/tables/networking/sharedCarrierProfilesTableService.js